import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-jalaali';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-node-log',
  templateUrl: './node-log.component.html',
  styleUrls: ['./node-log.component.scss']
})
export class NodeLogComponent extends BaseComponent implements OnInit {
  exportFileName = '-' + moment(new Date()).format('jYYYY/jMM/jDD HH:mm:ss');
  modal = false;
  nodeData: any = [];
  data: any = [];
  labels: any = [];
  nodeOption: any = {
    responsive: true,
    title: {
      display: false
    },
    scales: {
      xAxes: [{
        ticks: {
          autoSkip: true,
          minRotation: 90
        }
      }]
    }
  };
  nodeChartColor: any = [{
    fill: false,
    backgroundColor: 'rgba(255,255,0,0.4)',
    borderColor: 'rgba(255,204,153,1)',
    borderCapStyle: 'butt',
    borderDash: [],
    borderWidth: 2,
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: 'rgba(255,255,0,1)',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: 'rgba(255,255,0,1)',
    pointHoverBorderColor: 'rgba(220,220,220,1)',
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10,
    spanGaps: false
  },
  {
    fill: false,
    backgroundColor: 'rgba(75,192,192,0.4)',
    borderColor: 'rgba(75,192,192,1)',
    borderCapStyle: 'butt',
    borderDash: [],
    borderWidth: 2,
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: 'rgba(75,192,192,1)',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
    pointHoverBorderColor: 'rgba(220,220,220,1)',
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10,
    spanGaps: false,
  },
  {
    fill: false,
    backgroundColor: 'rgba(54, 162, 235,0.4)',
    borderColor: 'rgba(54, 162, 235,1)',
    borderCapStyle: 'butt',
    borderDash: [],
    borderWidth: 4,
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: 'rgba(54, 162, 235,1)',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: 'rgba(54, 162, 235,1)',
    pointHoverBorderColor: 'rgba(220,220,220,1)',
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10,
    spanGaps: false
  },
  {
    fill: false,
    backgroundColor: 'rgba(245,61,61,0.4)',
    borderColor: 'rgba(245,61,61,1)',
    borderCapStyle: 'butt',
    borderDash: [],
    borderWidth: 4,
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: 'rgba(245,61,61,1)',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: 'rgba(245,61,61,1)',
    pointHoverBorderColor: 'rgba(220,220,220,1)',
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10,
    spanGaps: false
  }];

  @Input() id: number;
  @Input() name: number;
  @Input() node_data: any;
  constructor(
    public service: BaseRichService,
    public activeModal: NgbActiveModal,
    public translator: TranslateService,
    public cookieService: CookieService,
    public route: ActivatedRoute,
    public titleService: Title,) {
    super(service, translator, cookieService, titleService);
  }

  // async ngOnInit() {
  //   if (this.id) {
  //     this.modal = true;
  //     this.refresh();
  //   } else {
  //     this.route.params.subscribe(params => {
  //       this.id = params.id;
  //       this.refresh();
  //     });
  //   }
  // }

  // refresh() {
  //   this.service.apiCall('api/node/read', { query: ['id', '=', this.id], fields: ['name', 'data'] }).subscribe(nodeResult => {
  //     if (nodeResult.ok) {
  //       const nodeJsonResult = nodeResult.json();
  //       this.name = nodeJsonResult[0].name;
  //       this.node_data = nodeJsonResult[0].data;
  //       this.service.readLog(this.id).subscribe((result: any) => {
  //         this.data = result.json().reverse().slice(0, 20);
  //         this.nodeData = [
  //           { data: this.data.map(i => i.min), label: 'min' },
  //           { data: this.data.map(i => i.avg), label: 'avg' },
  //           { data: this.data.map(i => i.max), label: 'max' },
  //           { data: this.data.map(i => i.stddev), label: 'stddev' },
  //         ];
  //         this.labels = this.data.map(i => moment(i.created_at).format('jYYYY/jMM/jDD HH:mm:ss'));
  //       });
  //     }
  //   });
  // }

  maximize() {
    window.open('#/technical/node-log/' + this.id, '_blank');
    this.activeModal.dismiss('Cross click');
  }

}
